import { z } from "zod";
import { defineEvent } from "./_define";
import { baseEnvelopeSchema } from "./_envelope";

export const MDI_INTAKE_STARTED_VALUES = {
  TRIAGE: "triage",
  DIRECT: "direct",
  UNKNOWN: "unknown",
} as const;
export type MdiIntakeStartedValue =
  (typeof MDI_INTAKE_STARTED_VALUES)[keyof typeof MDI_INTAKE_STARTED_VALUES];

export const MDI_INTAKE_COMPLETED_VALUES = {
  TRIAGE: "triage",
  DIRECT: "direct",
  UNKNOWN: "unknown",
} as const;
export type MdiIntakeCompletedValue =
  (typeof MDI_INTAKE_COMPLETED_VALUES)[keyof typeof MDI_INTAKE_COMPLETED_VALUES];

const mdiEnvelope = baseEnvelopeSchema.passthrough();

export const mdiQuestionnaireLoaded = defineEvent({
  eventName: "mdi_questionnaire_loaded",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: mdiEnvelope,
});

export const mdiIntakeStarted = defineEvent({
  eventName: "mdi_intake_started",
  eventVersion: 1,
  valueSchema: z
    .enum([
      MDI_INTAKE_STARTED_VALUES.TRIAGE,
      MDI_INTAKE_STARTED_VALUES.DIRECT,
      MDI_INTAKE_STARTED_VALUES.UNKNOWN,
    ])
    .or(z.string())
    .optional(),
  metadataSchema: mdiEnvelope,
});

export const mdiIntakeCompleted = defineEvent({
  eventName: "mdi_intake_completed",
  eventVersion: 1,
  valueSchema: z
    .enum([
      MDI_INTAKE_COMPLETED_VALUES.TRIAGE,
      MDI_INTAKE_COMPLETED_VALUES.DIRECT,
      MDI_INTAKE_COMPLETED_VALUES.UNKNOWN,
    ])
    .or(z.string())
    .optional(),
  metadataSchema: mdiEnvelope,
});

export const mdiQuestionnaireUnload = defineEvent({
  eventName: "mdi_questionnaire_unload",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: mdiEnvelope,
});

export const mdiQuestionnaireStep = defineEvent({
  eventName: "mdi_questionnaire_step",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: mdiEnvelope,
});

export const mdiEncounterCreated = defineEvent({
  eventName: "mdi_encounter_created",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: mdiEnvelope,
});

export const mdiPatientCreated = defineEvent({
  eventName: "mdi_patient_created",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: mdiEnvelope,
});

export const mdiQuestionSkipped = defineEvent({
  eventName: "mdi_question_skipped",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: mdiEnvelope,
});

export const mdiDeadEndQuestion = defineEvent({
  eventName: "mdi_dead_end_question",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: mdiEnvelope,
});

export const mdiPatientLoggedIn = defineEvent({
  eventName: "mdi_patient_logged_in",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: mdiEnvelope,
});
